export const convertPayload = (value: unknown) => {
  if (value === 'true') return true;
  if (value === 'false') return false;
  if (value === undefined) return null;

  return value;
};

export const convertPricePayloadToNumber = (value: string) => {
  if (value) {
    return Number(value.replace(/[^0-9]/g, '').slice(0, 9));
  }

  return null;
};
